// extracted by mini-css-extract-plugin
module.exports = {"container":"noPage_container__2c3Me","errorBK":"noPage_errorBK__2K4d-","centerHW":"noPage_centerHW__1x3qq","btn01":"noPage_btn01__2PxDG"};